import request from "@/utils/request";

export default function addGroup(data) {
  return request({
    url: `/device/deviceGroup/addGroup`,
    method: "post",
    data,
  });
}
